export { PatientList } from './patients/PatientList';

export const meta = {
  label: 'Patients',
  order: 31,
  section: 'User Lookup',
};
